import React from 'react';
import { PortfolioTableItemDetails } from '../PortfolioTableItem';
import { formatDate } from '../../../utils/dateUtils';
import { SectionBlock } from './SectionBlock';

type AdditionalDetailsSectionProps = { portfolio: PortfolioTableItemDetails };

export const AdditionalDetailsSection: React.FC<AdditionalDetailsSectionProps> = ({ portfolio }) => {
  const detailItems = [
    { label: 'Created at', value: formatDate(portfolio.createdAt) ?? '' },
    { label: 'Created by', value: portfolio.createdBy ?? '' },
    {
      label: 'Activated at',
      value: formatDate(portfolio.activatedAt) ?? '',
      testId: 'portfolio-detail-activated-at',
    },
    { label: 'Activated by', value: '' },
    { label: 'Closure requested at', value: '' },
    { label: 'Closure requested by', value: '' },
    { label: 'In closing at', value: '' },
    { label: 'In closing by', value: '' },
    { label: 'Closed at', value: formatDate(portfolio.closedAt) ?? '', testId: 'portfolio-detail-closed-at' },
    { label: 'Closed by', value: '' },
    { label: 'Modified at', value: formatDate(portfolio.modifiedAt) ?? '' },
    { label: 'Modified by', value: portfolio.modifiedBy ?? '' },
  ];

  return <SectionBlock list={detailItems} />;
};
